"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step3;
    try {
      var _loop = function _loop() {
        var key = _step3.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Box: function Box() {
    return _Box;
  },
  CAN_USE_DOM: function CAN_USE_DOM() {
    return _CAN_USE_DOM;
  },
  DEFAULT_IGNORE_CLASS: function DEFAULT_IGNORE_CLASS() {
    return _DEFAULT_IGNORE_CLASS;
  },
  PortalBody: function PortalBody() {
    return _PortalBody;
  },
  Text: function Text() {
    return _Text;
  },
  composeEventHandlers: function composeEventHandlers() {
    return _composeEventHandlers;
  },
  composeRefs: function composeRefs() {
    return _composeRefs;
  },
  createPrimitiveComponent: function createPrimitiveComponent() {
    return _createPrimitiveComponent;
  },
  createPrimitiveElement: function createPrimitiveElement() {
    return _createPrimitiveElement;
  },
  createSlotComponent: function createSlotComponent() {
    return _createSlotComponent;
  },
  useComposedRef: function useComposedRef() {
    return _useComposedRef;
  },
  useIsomorphicLayoutEffect: function useIsomorphicLayoutEffect() {
    return _useIsomorphicLayoutEffect;
  },
  useOnClickOutside: function useOnClickOutside() {
    return _useOnClickOutside;
  },
  useStableMemo: function useStableMemo() {
    return _useStableMemo;
  },
  withProviders: function withProviders() {
    return _withProviders;
  },
  withRef: function withRef() {
    return _withRef;
  }
});
module.exports = __toCommonJS(src_exports);

// src/createSlotComponent.tsx
var import_react = __toESM(require("react"));
var import_react_slot = require("@radix-ui/react-slot");
var _createSlotComponent = function _createSlotComponent(element) {
  return (
    // eslint-disable-next-line react/display-name
    import_react.default.forwardRef(function (_a2, ref) {
      var _b = _a2,
        as = _b.as,
        _b$asChild = _b.asChild,
        asChild = _b$asChild === void 0 ? false : _b$asChild,
        props = __objRest(_b, ["as", "asChild"]);
      var Comp = asChild ? import_react_slot.Slot : as || element;
      return /* @__PURE__ */import_react.default.createElement(Comp, __spreadValues({
        ref: ref
      }, props));
    })
  );
};

// src/Box.tsx
var _Box = _createSlotComponent("div");

// src/PortalBody.tsx
var import_react2 = __toESM(require("react"));
var import_react_dom = __toESM(require("react-dom"));
var _PortalBody = function _PortalBody(_ref2) {
  var children = _ref2.children,
    element = _ref2.element;
  var container = element || typeof window !== "undefined" ? document.body : void 0;
  if (!container) return /* @__PURE__ */import_react2.default.createElement(import_react2.default.Fragment, null, children);
  return import_react_dom.default.createPortal(children, element || document.body);
};

// src/Text.tsx
var _Text = _createSlotComponent("span");

// src/composeEventHandlers.ts
var _composeEventHandlers = function _composeEventHandlers(originalEventHandler, ourEventHandler) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref3$checkForDefault = _ref3.checkForDefaultPrevented,
    checkForDefaultPrevented = _ref3$checkForDefault === void 0 ? true : _ref3$checkForDefault;
  return function (event) {
    originalEventHandler == null ? void 0 : originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler == null ? void 0 : ourEventHandler(event);
    }
  };
};

// src/createPrimitiveComponent.tsx
var import_react4 = __toESM(require("react"));
var import_utils = require("@udecode/utils");
var import_clsx = require("clsx");

// src/useComposedRef.ts
var import_react3 = __toESM(require("react"));
var setRef = function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
};
var _composeRefs = function _composeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (node) {
    return refs.forEach(function (ref) {
      return setRef(ref, node);
    });
  };
};
var _useComposedRef = function _useComposedRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return import_react3.default.useCallback(_composeRefs.apply(void 0, refs), refs);
};

// src/createPrimitiveComponent.tsx
var _createPrimitiveComponent = function _createPrimitiveComponent(element) {
  var Comp = _createSlotComponent(element);
  return function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      propsHook = _ref4.propsHook,
      stateHook = _ref4.stateHook;
    return import_react4.default.forwardRef(function (_a2, ref) {
      var _b = _a2,
        asChild = _b.asChild,
        classNameProp = _b.className,
        getClassName = _b.getClassName,
        options = _b.options,
        stateProp = _b.state,
        props = __objRest(_b, ["asChild", "className", "getClassName", "options", "state"]);
      var _a3, _b2;
      var state = (0, import_utils.isDefined)(stateProp) ? stateProp : stateHook ? stateHook(options) : void 0;
      var _ref5 = propsHook ? propsHook(state) : {
          hidden: false,
          props: {},
          ref: null
        },
        hidden = _ref5.hidden,
        hookProps = _ref5.props,
        hookRef = _ref5.ref;
      var _ref = _useComposedRef(ref, hookRef);
      var className = (0, import_utils.isDefined)(hookProps == null ? void 0 : hookProps.className) || (0, import_utils.isDefined)(classNameProp) ? (0, import_clsx.clsx)(hookProps == null ? void 0 : hookProps.className, classNameProp) : void 0;
      var style = (hookProps == null ? void 0 : hookProps.style) || props.style ? __spreadValues(__spreadValues({}, hookProps == null ? void 0 : hookProps.style), props.style) : void 0;
      if (!asChild && hidden) return null;
      return /* @__PURE__ */import_react4.default.createElement(Comp, __spreadValues(__spreadValues(__spreadProps(__spreadValues({
        asChild: asChild,
        ref: _ref
      }, hookProps), {
        className: className,
        style: style
      }), props), (_b2 = (_a3 = props.setProps) == null ? void 0 : _a3.call(props, hookProps != null ? hookProps : {})) != null ? _b2 : {}));
    });
  };
};

// src/createPrimitiveElement.tsx
var import_react5 = __toESM(require("react"));
function _createPrimitiveElement(tag) {
  return import_react5.default.forwardRef(function CreateComponent(props, ref) {
    return import_react5.default.createElement(tag, __spreadProps(__spreadValues({}, props), {
      ref: ref
    }));
  });
}

// src/useIsomorphicLayoutEffect.ts
var import_react6 = __toESM(require("react"));
var _a;
var _CAN_USE_DOM = typeof window !== "undefined" && ((_a = window.document) == null ? void 0 : _a.createElement) !== void 0;
var _useIsomorphicLayoutEffect = _CAN_USE_DOM ? import_react6.default.useLayoutEffect : import_react6.default.useEffect;

// src/useOnClickOutside.ts
var import_react7 = __toESM(require("react"));
var canUsePassiveEvents = function canUsePassiveEvents() {
  if (typeof window === "undefined" || typeof window.addEventListener !== "function") return false;
  var passive = false;
  var options = Object.defineProperty({}, "passive", {
    // eslint-disable-next-line getter-return
    get: function get() {
      passive = true;
    }
  });
  var noop = function noop() {
    return null;
  };
  window.addEventListener("test", noop, options);
  window.removeEventListener("test", noop, options);
  return passive;
};
var _DEFAULT_IGNORE_CLASS = "ignore-onclickoutside";
var checkClass = function checkClass(el, cl) {
  var _a2;
  return (_a2 = el.classList) == null ? void 0 : _a2.contains(cl);
};
var hasIgnoreClass = function hasIgnoreClass(e, ignoreClass) {
  var el = e.target || e;
  while (el) {
    if (Array.isArray(ignoreClass)) {
      if (ignoreClass.some(function (c) {
        return checkClass(el, c);
      })) return true;
    } else if (checkClass(el, ignoreClass)) {
      return true;
    }
    el = el.parentElement;
  }
  return false;
};
var clickedOnScrollbar = function clickedOnScrollbar(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
};
var getEventOptions = function getEventOptions(type) {
  return type.includes("touch") && canUsePassiveEvents() ? {
    passive: true
  } : false;
};
var _useOnClickOutside = function _useOnClickOutside(callback) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref6$detectIFrame = _ref6.detectIFrame,
    detectIFrame = _ref6$detectIFrame === void 0 ? true : _ref6$detectIFrame,
    disabled = _ref6.disabled,
    _ref6$eventTypes = _ref6.eventTypes,
    eventTypes = _ref6$eventTypes === void 0 ? ["mousedown", "touchstart"] : _ref6$eventTypes,
    excludeScrollbar = _ref6.excludeScrollbar,
    _ref6$ignoreClass = _ref6.ignoreClass,
    ignoreClass = _ref6$ignoreClass === void 0 ? _DEFAULT_IGNORE_CLASS : _ref6$ignoreClass,
    refsOpt = _ref6.refs;
  var _import_react7$defaul = import_react7.default.useState([]),
    _import_react7$defaul2 = _slicedToArray(_import_react7$defaul, 2),
    refsState = _import_react7$defaul2[0],
    setRefsState = _import_react7$defaul2[1];
  var callbackRef = import_react7.default.useRef(callback);
  callbackRef.current = callback;
  var ref = import_react7.default.useCallback(function (el) {
    return setRefsState(function (prevState) {
      return [].concat(_toConsumableArray(prevState), [{
        current: el
      }]);
    });
  }, []);
  import_react7.default.useEffect(function () {
    if (!(refsOpt == null ? void 0 : refsOpt.length) && refsState.length === 0) return;
    var getEls = function getEls() {
      var els = [];
      (refsOpt || refsState).forEach(function (_ref7) {
        var current = _ref7.current;
        return current && els.push(current);
      });
      return els;
    };
    var handler = function handler(e) {
      if (!hasIgnoreClass(e, ignoreClass) && !(excludeScrollbar && clickedOnScrollbar(e)) && getEls().every(function (el) {
        return !el.contains(e.target);
      })) callbackRef.current(e);
    };
    var blurHandler = function blurHandler(e) {
      return (
        // On firefox the iframe becomes document.activeElement in the next event loop
        setTimeout(function () {
          var _document = document,
            activeElement = _document.activeElement;
          if ((activeElement == null ? void 0 : activeElement.tagName) === "IFRAME" && !hasIgnoreClass(activeElement, ignoreClass) && !getEls().includes(activeElement)) callbackRef.current(e);
        }, 0)
      );
    };
    var removeEventListener = function removeEventListener() {
      eventTypes.forEach(function (type) {
        return document.removeEventListener(type, handler, getEventOptions(type));
      });
      if (detectIFrame) window.removeEventListener("blur", blurHandler);
    };
    if (disabled) {
      removeEventListener();
      return;
    }
    eventTypes.forEach(function (type) {
      return document.addEventListener(type, handler, getEventOptions(type));
    });
    if (detectIFrame) window.addEventListener("blur", blurHandler);
    return function () {
      return removeEventListener();
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [refsState, ignoreClass, excludeScrollbar, disabled, detectIFrame,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(eventTypes)]);
  return ref;
};

// src/useStableMemo.ts
var import_react8 = __toESM(require("react"));
var _useStableMemo = function _useStableMemo(producer, deps) {
  var _import_react8$defaul = import_react8.default.useState(producer),
    _import_react8$defaul2 = _slicedToArray(_import_react8$defaul, 2),
    value = _import_react8$defaul2[0],
    setValue = _import_react8$defaul2[1];
  import_react8.default.useLayoutEffect(function () {
    setValue(producer);
  }, deps);
  return value;
};

// src/withProviders.tsx
var import_react9 = __toESM(require("react"));
var _withProviders = function _withProviders() {
  for (var _len3 = arguments.length, providers = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    providers[_key3] = arguments[_key3];
  }
  return function (WrappedComponent) {
    return function (props) {
      return providers.reduceRight(function (acc, prov) {
        var Provider = prov;
        if (Array.isArray(prov)) {
          var _prov = _slicedToArray(prov, 1);
          Provider = _prov[0];
          return /* @__PURE__ */import_react9.default.createElement(Provider, __spreadValues({}, prov[1]), acc);
        }
        return /* @__PURE__ */import_react9.default.createElement(Provider, null, acc);
      }, /* @__PURE__ */import_react9.default.createElement(WrappedComponent, __spreadValues({}, props)));
    };
  };
};

// src/withRef.tsx
var import_react10 = __toESM(require("react"));
function _withRef(renderFunction) {
  return import_react10.default.forwardRef(renderFunction);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Box: _Box,
  CAN_USE_DOM: _CAN_USE_DOM,
  DEFAULT_IGNORE_CLASS: _DEFAULT_IGNORE_CLASS,
  PortalBody: _PortalBody,
  Text: _Text,
  composeEventHandlers: _composeEventHandlers,
  composeRefs: _composeRefs,
  createPrimitiveComponent: _createPrimitiveComponent,
  createPrimitiveElement: _createPrimitiveElement,
  createSlotComponent: _createSlotComponent,
  useComposedRef: _useComposedRef,
  useIsomorphicLayoutEffect: _useIsomorphicLayoutEffect,
  useOnClickOutside: _useOnClickOutside,
  useStableMemo: _useStableMemo,
  withProviders: _withProviders,
  withRef: _withRef
});